// src/pages/super-admin/Clients/ClientReportsSection.tsx
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import ClientVisitorLabReports from "../../reports/pages/ClientVisitorLabReports";

interface ClientReportsSectionProps {
  clientId: number;
}

export default function ClientReportsSection({ clientId }: ClientReportsSectionProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Visitor Lab Reports</CardTitle>
      </CardHeader>
      <CardContent>
        <ClientVisitorLabReports clientId={clientId} />
      </CardContent>
    </Card>
  );
}
